import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import CMSImage from '../../../Assets/cms/finalIcons/dashboard-c.webp'
import features from '../../../Assets/cms/CMS_features.png'

export default function CMS({toggleOverlay}) {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const items = [
        {
            title: "Simple integration",
            content: "Seamlessly connect the CMS with your existing systems using standard APIs and protocols. Our charger management system is designed for quick deployment, minimal setup time, and hassle-free integration with billing, CRM, and other platforms.",
        },
        {
            title: "Transparent payments",
            content: "Get complete visibility into every transaction with real-time payment tracking and detailed reports. Our system ensures secure, accurate, and hassle-free settlements for both operators and EV users.",
        },
        {
            title: "Smart load management",
            content: "Optimize energy usage across charging stations with intelligent load balancing that prevents grid overload. Our system dynamically adjusts power distribution based on demand, ensuring efficient and reliable charging at all times.",
        },
    ];

    const [openIndex, setOpenIndex] = useState(null);

    const toggleIndex = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="containers-min mx-auto px-4 py-12 space-y-8 blade-margin-top-sm ">
            <div className="text-center">
                <h3 className="text-center font-gilroy">
                    Charger Management Software
                </h3>
                <p className="leading-normal font-poppins text-center px-5 pt-4 text-base md:text-xl lg:text-2xl">
                    A scalable, cloud-based plaform designed to deploy, monitor, and grow your EV charging network with ease
                </p>
            </div>

            <div className="bg-grey rounded-3xl p-6 sm:p-10 flex flex-col-reverse md:flex-row items-center justify-between gap-6">
                {/* Text Content */}
                <div className="w-full md:w-1/2 space-y-4 text-start md:text-left">
                    <ul className="space-y-4">
                        {items.map((item, index) => (
                            <li
                                key={index}
                                className="border border-verde px-6 py-4 rounded-2xl"
                            >
                                <button
                                    onClick={() => toggleIndex(index)}
                                    className="w-full flex items-center justify-between focus:outline-none"
                                >
                                    <p className='font-gilroy'>{item.title}</p>
                                    <div className="bg-black bg-opacity-30 rounded-full p-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className={`h-5 w-5 transform transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                                                }`}
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </button>

                                {openIndex === index && (
                                    <div className="mt-3 text-gray-600 text-lg font-poppins">
                                        {item.content}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                    <div className='flex space-x-4'>
                        <div
                            className='mt-5'
                            onClick={toggleOverlay}
                        >
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Schedule a Demo
                            </button>
                        </div>
                        {/* <div
                            className='mt-5'
                            onClick={() => setShowModal(true)}
                        >
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Features
                            </button>
                        </div> */}
                    </div>
                </div>

                {/* Image */}
                <div className="md:w-1/2 flex justify-center">
                    <img
                        src={CMSImage}
                        alt="Dashboard Screenshot"
                        className="max-w-full h-auto"
                    />
                </div>
            </div>
            {showModal && (
                <div className="fixed !m-0 inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white rounded-2xl p-8 max-w-5xl w-full shadow-xl relative">
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-2 right-4 text-2xl font-bold text-gray-700"
                        >
                            &times;
                        </button>
                        <h2 className="text-xl font-bold mb-4">Features</h2>
                        <div>
                            <img src={features} alt="features" className='w-full h-full' />
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
